export default __webpack_public_path__ + "static/media/home2.c725604d.png";